import clsx from "clsx";

export function Skeleton({ className }: { className?: string }) {
  return (
    <div
      className={clsx(
        "animate-pulse rounded-md bg-surface-200/70 dark:bg-slate-800/70",
        className,
      )}
    />
  );
}
